import React from 'react';
import { Formik, Form, FormikProps, FieldArray, Field, FieldProps } from 'formik';
import { Container, Col, Row, Label, Button } from 'reactstrap';
import { TextInput } from 'src/components/TextInput';
import { TextArea } from 'src/components/TextArea';
import { RemoteSelect, Datum } from 'src/components/RemoteSelect';

export interface IRecipeFormValue {
  id?: string,
  name: string,
  instructions: string,
  ingredients: {
    name: string,
    quantity: number,
    unit: string
  }[]
}

export interface IRecipeForm {
  defaultValue?: IRecipeFormValue,
  onSubmit(formData: IRecipeFormValue): void,
  location: string
}

interface State {
  units: string[]
}
export class RecipeForm extends React.PureComponent<IRecipeForm, {}> {

  constructor(props: IRecipeForm) {
    super(props);

    this.state = {
      units: []
    }
  }

  fetchData = (): Promise<Datum[]> => {
    return fetch('http://dev.kevingnadinger.com/ingredients/units')
      .then(res => res.json())
      .then(res => res.units.map((unit: string) => {
        return {
          value: unit,
          label: unit
        }
      }))
  }

  render() {
    if (!this.props.defaultValue) { return (<div>Loading...</div>) }
    return (
      <Formik
        initialValues={this.props.defaultValue}
        onSubmit={values => {
          this.props.onSubmit(values);
        }}
        render={
          (props: FormikProps<any>) => (
            <Form>
              <Row>
                <Col md={2}>
                  <Label>Name</Label>
                </Col>
                <Col md={5}>
                  <Field name={`name`} component={TextInput} />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <Label>Instructions</Label>
                </Col>
                <Col md={10}>
                  <Field name="instructions" component={TextArea} />
                </Col>
              </Row>
              <Row><Col><h3>Ingredients</h3></Col></Row>
              <FieldArray
                name="ingredients"
                render={arrayHelpers => (
                  <div>
                    {props.values.ingredients.map((ingredient: any, index: number) => (
                      <Row key={index}>
                        <Col md={2}><Label>{index + 1}.</Label></Col>
                        <Col md="auto"><Field name={`ingredients.${index}.name`} placeholder="Name" component={TextInput} /></Col>
                        <Col md={2}><Field name={`ingredients.${index}.quantity`} type="number" placeholder="Qty" component={TextInput} /></Col>
                        <Col md={2}>
                          <RemoteSelect
                            name={`ingredients.${index}.unit`}
                            label="Select Unit"
                            fetchdata={this.fetchData}
                          />
                        </Col>
                        <Col md={1}><Button outline color="danger" type="button" onClick={() => arrayHelpers.remove(index)}>-</Button></Col>
                      </Row>
                    ))}
                    <Row>
                      <Col><Button color="info" outline type="button" onClick={() => arrayHelpers.push({ name: '', unit: '', quantity: 0 })}>Add Ingredient</Button></Col>
                    </Row>
                  </div>
                )}
              />
              <Button color="primary" type="submit">Submit</Button>
            </Form>
          )
        }
      />
    )
  }
}